// import logo from './logo.svg';
import "./App.css";

import { Switch, Route, Redirect } from "react-router-dom";

// import WithSpinner from "./HOC/WithSpinner.component";

import HeaderPu from "./containers/HeaderPu/HeaderPu.component";

import PublicReqList from "./pages/public-reqList/PublicReqList.page";
import SingleReq from "./pages/single-req/SingleReq.page";

// const WithSpinnerSingleReq = WithSpinner(SingleReq);

function App() {
  return (
    <div className="App">
      {/* <div>asdf</div> */}

      {/* <Route path="/xxx" component={() => <div>hi index</div>} /> */}
      {/* <Route exact path="/" component={PublicReqList} /> */}
      {/* <Route path="./"> */}
      <HeaderPu />
      {/* </Route> */}

      <Switch>
        {/* <Switch> */}
        {/* <Route exact path="/pu/*" component={HeaderPu} /> */}
        <Route exact path="/">
          <Redirect to="/requests/page/1" />
        </Route>
        <Route exact path="/requests/">
          <Redirect to="/requests/page/1" />
        </Route>

        <Route exact path="/requests/page/:pageNo/" component={PublicReqList} />

        <Route exact path="/load/:id" component={SingleReq} />
      </Switch>

      {/* <Footer /> */}
    </div>
  );
}

export default App;
